import {
  ZIP_CODE,
  PHONE_NUMBER,
  SSN_ORG_NUMBER,
  PHONE_NUMBER_MIN_LENGTH,
  PHONE_NUMBER_MAX_LENGTH,
  EMAIL,
} from '@client/definitions/formFieldNames';

export const formFieldErrorTranslations = {
  [ZIP_CODE]: 'Postnumret är inte giltigt',
  [PHONE_NUMBER]:
    'Ange ett giltigt telefonnummer med endast siffror, utan mellanslag och landskod',
  [PHONE_NUMBER_MAX_LENGTH]: 'Telefonnumret får vara max 15 tecken långt',
  [PHONE_NUMBER_MIN_LENGTH]: 'Telefonnumret måste vara minst 5 tecken långt',
  [SSN_ORG_NUMBER]: 'Ange ett organisationsnummer i formatet NNNNNN-NNNN',
  [EMAIL]: 'Ange en giltig mailadress',
};
